<div
  class="overflow-hidden rounded-lg bg-slate100 flex items-center justify-center"
  [ngClass]="sizeClasses()"
>
  @if (showPrimary()) {
    <img
      [src]="src()"
      [alt]="alt()"
      class="w-full h-full object-cover"
      (error)="onPrimaryError()"
    />
  } @else if (showBrandImage()) {
    <img
      [src]="brandImageUrl()"
      [alt]="alt() || brandName()"
      class="w-full h-full object-contain p-1"
      (error)="onBrandError()"
    />
  } @else {
    <i class="fas fa-car text-slate500 text-base"></i>
  }
</div>
